import React, {useState} from 'react';
import {Tabs, Tab} from '@mui/material';
import PartnerDashboardShell from '../components/PartnerDashboard.comp';
import DeploymentMapTab from '../tabs/DeploymentMap.tab';
import ByCountryTab from '../tabs/ByCountry.tab';
import ByClientSchoolTab from '../tabs/ByClientSchool.tab';

const ORANGE = '#FF6900';

/* ── Main page ──────────────────────────────────────────────────── */
const CountryClientPage = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <PartnerDashboardShell
            tabs={
                <Tabs
                    value={activeTab}
                    onChange={(_, v) => setActiveTab(v)}
                    TabIndicatorProps={{style: {backgroundColor: ORANGE}}}
                    sx={{
                        borderBottom: '1px solid #E5E7EB',
                        mb: 1,
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '14px',
                            color: '#6A7282',
                            px: 2,
                        },
                        '& .Mui-selected': {color: `${ORANGE} !important`},
                    }}
                >
                    <Tab label="Overview"/>
                    <Tab label="By Country"/>
                    <Tab label="By School"/>
                </Tabs>
            }
        >
            {activeTab === 0 && <DeploymentMapTab/>}
            {activeTab === 1 && <ByCountryTab/>}
            {activeTab === 2 && <ByClientSchoolTab/>}
        </PartnerDashboardShell>
    );
};

export default CountryClientPage;
